<template>
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon--energy"
  >
    <g clip-path="url(#iconEnergieClip)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.3884 25.4379H42.8063C42.5632 25.4379 42.3235 25.3804 42.1069 25.2698C41.8904 25.1592 41.7032 24.9988 41.5606 24.8019C41.418 24.6049 41.3243 24.377 41.2869 24.1367C41.2495 23.8965 41.2696 23.6508 41.3456 23.4198C42.0087 23.6601 42.5372 23.6505 42.5468 22.8529C42.0759 22.4877 42.0375 22.5837 41.5858 22.6798L42.0279 21.3345C42.081 21.3693 42.1394 21.3953 42.2009 21.4113C41.8261 20.8251 42.5853 21.2671 42.4604 20.6232H42.249L48.4378 1.66253C48.4716 1.55951 48.4716 1.44846 48.4378 1.34544C48.3779 1.05178 48.2422 0.778814 48.0444 0.553707C47.8465 0.328599 47.5933 0.159162 47.3098 0.0620571C47.0262 -0.0350477 46.7222 -0.0564273 46.4278 0.000116955C46.1335 0.0566612 45.859 0.189168 45.6316 0.384427L0.733259 41.4195C0.489486 41.6434 0.319508 41.936 0.245715 42.2586C0.171923 42.5813 0.197863 42.9187 0.32009 43.2262C0.43746 43.5332 0.645643 43.7971 0.916968 43.9825C1.18829 44.168 1.5098 44.2663 1.83844 44.2642H33.4557C33.5303 44.2642 33.6039 44.2815 33.6706 44.3149C33.7373 44.3482 33.7954 44.3967 33.8401 44.4563C33.8849 44.516 33.9151 44.5853 33.9285 44.6587C33.9418 44.7321 33.9379 44.8076 33.917 44.8793L27.3629 67.8666C27.2586 68.2184 27.2779 68.5953 27.4178 68.9345C27.5577 69.2738 27.8097 69.5549 28.1317 69.731C28.3789 69.8773 28.6612 69.9537 28.9485 69.952C29.1684 69.9519 29.3859 69.9067 29.5876 69.8191C29.7893 69.7315 29.9709 69.6033 30.121 69.4426L69.5801 28.1192C69.8043 27.8893 69.9555 27.598 70.0142 27.2823C70.073 26.9665 70.0368 26.6405 69.9103 26.3453C69.7838 26.0501 69.5726 25.799 69.3034 25.6239C69.0343 25.4487 68.7192 25.3572 68.398 25.3611L68.3884 25.4379ZM66.9469 28.1673L30.8609 65.9253C30.7866 66.0012 30.6892 66.0504 30.5839 66.065C30.4787 66.0797 30.3716 66.0591 30.2793 66.0064C30.187 65.9536 30.1148 65.8717 30.074 65.7736C30.0332 65.6755 30.026 65.5666 30.0537 65.464L36.0312 44.4756C36.1011 44.2326 36.1136 43.9767 36.0679 43.7281C36.0221 43.4794 35.9193 43.2449 35.7674 43.0428C35.6156 42.8406 35.4189 42.6764 35.1929 42.5632C34.9668 42.45 34.7175 42.3907 34.4647 42.3902H3.80856C3.71127 42.3909 3.61601 42.3621 3.53546 42.3076C3.45491 42.253 3.3928 42.1752 3.35739 42.0846C3.32197 41.9939 3.31488 41.8947 3.33709 41.8C3.3593 41.7052 3.40974 41.6195 3.48174 41.5541L44.8052 3.81518C44.8854 3.74711 44.9855 3.70668 45.0905 3.69987C45.1955 3.69305 45.3 3.72029 45.3883 3.77741C45.4767 3.83453 45.5443 3.91853 45.5812 4.01708C45.6181 4.11562 45.6224 4.22342 45.5933 4.32455L38.7796 25.2073C38.6994 25.4535 38.6785 25.7153 38.7186 25.9712C38.7587 26.2271 38.8587 26.4698 39.0105 26.6797C39.1623 26.8895 39.3616 27.0606 39.592 27.1788C39.8225 27.297 40.0776 27.3591 40.3366 27.3599H66.6298C66.7171 27.3726 66.7992 27.4091 66.8671 27.4653C66.9351 27.5215 66.9863 27.5953 67.0151 27.6787C67.0438 27.762 67.0491 27.8518 67.0303 27.9379C67.0115 28.0241 66.9693 28.1035 66.9084 28.1673H66.9469Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.5278 24.4673C42.326 24.2751 42.6527 24.6018 42.5278 24.4673V24.4673Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.0462 21.4305C44.0462 21.0365 44.4305 21.0077 44.3537 20.4695C43.6041 20.037 43.4504 21.5458 44.0462 21.4305Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.3633 22.872C44.4498 22.9584 44.3633 22.8143 44.3633 22.872V22.872Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.9692 24.1599C44.054 24.1719 44.1403 24.152 44.2113 24.104C44.2823 24.0561 44.333 23.9836 44.3536 23.9004C44.1518 23.9196 43.9019 23.8908 43.9692 24.1599Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.1418 24.0444H44.8823V24.3039H45.1418V24.0444Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.1417 25.8704C44.7669 25.2842 45.526 25.7262 45.401 25.0823C44.8148 25.0342 44.5362 25.707 45.1417 25.8704Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.3157 25.7358C43.6809 25.7358 44.2094 25.8511 44.2286 25.4764C44.0076 25.2745 43.3157 25.3322 43.3157 25.7358Z"
      />
    </g>
    <defs>
      <clipPath id="iconEnergieClip">
        <rect width="69.827" height="70" transform="translate(0.156738)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'IconEnergy',
}
</script>
